import { Component, Inject, ElementRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscriber } from '../../models/shared/subscriber-model';
import { SubscriberService } from '../../services/others/subscriber.service';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
  selector: 'app-subscriber-list',
  templateUrl: './subscriber-list.component.html',
  styleUrls: ['./subscriber-list.component.scss']
})
/** subscriber-list component*/
export class SubscriberListComponent {
  /** subscriber-list ctor */
  public subscriberList: Subscriber[];
  //Filter items from grid
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isFileDownload: boolean = false;
  @ViewChild('fileDownload') fileDownload: ElementRef;
  /** subscriber-list ctor */
  constructor(private readonly subscriberService: SubscriberService, private readonly utilitiesService: UtilitiesService,
    private readonly router: Router, private readonly rolePermissionService: RolePermissionService,
    public toastr: ToastsManager, vcr: ViewContainerRef) {

    this.toastr.setRootViewContainerRef(vcr);

    this.rolePermissionService.GetRolePermissions("subscriber").subscribe(
      data => {
        if (data != null) {

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });
          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
            this.getsubscribers();
            this.GetRowsPerPageList();
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }

  deletesubscriber(id) {
    var ans = confirm("Are you sure to delete this subscriber?");
    if (ans) {
      this.subscriberService.deleteSubscriber(id);
      setTimeout(() => {
        this.getsubscribers();
      }, 2000);
    }
  }
  getsubscribers() {
    this.subscriberService.getSubscribers().subscribe(
      data => {
        this.subscriberList = data;
        this.filteredItems = data;
      }
    )
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  onSearch(searchText: string) {
    if (searchText != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.subscriberList, searchText);

    } else {
      this.filteredItems = this.subscriberList;
    }
  }

  exportSubscribers() {
    if (!this.isFileDownload) {
      this.isFileDownload = true;
      this.subscriberService.exportSubscribers().subscribe(
        data => {
          if (data.status == 1) {
            this.fileDownload.nativeElement.href = "/Files/" + data.data;
            this.fileDownload.nativeElement.click();
            this.toastr.success(data.message, 'Success');
            this.isFileDownload = false;
          }
          else {
            this.toastr.error(data.message, 'Error');
            this.isFileDownload = false;
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/subscribers/subscriber-list/subscriber-list.component.ts